import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import authConfig from './auth-config';
import PropTypes from 'prop-types';

const AuthProviderWithHistory = ({ children }) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname || "/");
  };
  return (
    <Auth0Provider
      domain={authConfig.domain}
      clientId={authConfig.clientId}
      authorizationParams={authConfig.authorizationParams}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={authConfig.useRefreshTokens}
      scope={authConfig.scope}
      audience={authConfig.audience}
      //organization={authConfig.organization}
      cacheLocation={authConfig.cacheLocation}>
      {children}
    </Auth0Provider>
  )
};


AuthProviderWithHistory.propTypes = {
  children: PropTypes.node,
};


export default AuthProviderWithHistory;
